import React from 'react';
import TopupCreditsModal from './TopupCreditsModal';
import { useTopupCreditsModal } from '../context/TopupCreditsModalContext';

/**
 * Renders the shell-level Top up Credits modal while it is open. Mounted only
 * when open, so the modal's contract and balance reads run per opening.
 */
export default function TopupCreditsModalHost() {
  const { isOpen, close } = useTopupCreditsModal();

  if (!isOpen) {
    return null;
  }

  return <TopupCreditsModal visible onClose={close} />;
}
